import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import Link from 'components/base/Link';
import Navigation from 'components/base/navigation/navigation';

const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  margin: 0 auto;
  border-radius: 2px;
  z-index: 3;
  // background-color: ${(props) => props.theme.colors.white};
  ${down('md')} {
    display: none;
  }
`;

const NavContainer = styled.div`
  z-index: 3;
`;

const StickyLogoSlot = styled.div`
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  height: 54px;
  margin: 0px 16px 0px 5px;

  a {
    display: inline-flex;
    align-items: center;
    height: 100%;
  }

  @media screen and (max-width: 900px) {
    height: 44px;
    margin-right: 8px;
  }
`;

const StickyLogoImage = styled.img`
  display: block;
  width: 76px;
  height: 54px;
  object-fit: contain;

  @media screen and (max-width: 900px) {
    width: 62px;
    height: 44px;
  }
`;

export function Nav(props) {
  const { isSticky, ...rest } = props;

  return (
    <NavContainer {...rest}>
      <DesktopNav>
        {isSticky ? (
          <StickyLogoSlot>
            <Link to="/">
              <StickyLogoImage
                alt="Parkdale Centre"
                src="/images/logo-full.png"
              />
            </Link>
          </StickyLogoSlot>
        ) : null}
        <Navigation isMobileNav={false} />
      </DesktopNav>
    </NavContainer>
  );
}
